import React           from 'react';
import PropTypes       from 'prop-types';
import CamShowsItem    from './CamShowsItem';
import { generateKey } from '../../utils/CommonUtils';

class CamShowsGrid extends React.PureComponent {
  render() {
    return (
      <div className='cam-shows__grid'>
          { this.props.items.map((item, idx) => <CamShowsItem key={generateKey('camshows-item', idx)} parent="featured" item={item} onCloseModal={this.props.onCloseModal}/>) }
      </div>
    );
  }
}

CamShowsGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    actorName:   PropTypes.string,
    name:        PropTypes.string,
    actorAvatar: PropTypes.shape({
      url: PropTypes.string
    }),
    price:     PropTypes.shape({
        value:    PropTypes.number,
        currency: PropTypes.string,
        symbol:   PropTypes.string,
    }),
    actorLink: PropTypes.string,
    online:    PropTypes.bool,
    featured:  PropTypes.bool,
    imageUrl:  PropTypes.string,
    start:     PropTypes.string,
    end:       PropTypes.string,
  })),
  onCloseModal: PropTypes.func
};


export default CamShowsGrid;